import script from "./PricingJumbo.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingJumbo.vue?vue&type=script&setup=true&lang=js"

import "./PricingJumbo.vue?vue&type=style&index=0&id=9f6a4d9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f6a4d9a"]])

export default __exports__